"use client"

import { getBonusProductTitle } from "@/app/shared/bonus/config/consts"
import { Translate } from "@/components/ui/translate"
import { useConfigParams } from "@/hooks"
import { cn } from "@/lib/cn"
import { useBonusListQuery } from "@/services/get-bonus"
import useSignupRequestStore from "@/store/signup-request-store"
import { isErr } from "@pacote/result"
import { useTranslations } from "next-intl"
import Image from "next/image"
import { AppChannelsWithoutHeader } from "../components/layout/header-config"

export function PromoCodeBanner() {
  const promoBannerText = usePromoBannerText()
  const { channel } = useConfigParams()
  const hideSiteHeader =
    channel != null && AppChannelsWithoutHeader.includes(channel)

  return (
    <div
      className={cn(
        "sticky flex w-full justify-start bg-(image:--gradient-g-welcome-bonus) md:top-(--header-height-md) md:justify-center",
        hideSiteHeader ? "top-0" : "top-(--header-height)",
      )}
    >
      <div className="mx-auto flex w-full max-w-xl justify-start gap-2 px-4 py-1 text-white md:px-0">
        <PromoBannerImage />
        <span className="flex flex-wrap items-center text-left text-xs font-normal md:text-center md:text-sm">
          {promoBannerText}
        </span>
      </div>
    </div>
  )
}

function PromoBannerImage() {
  const computeImageSrc = () => {
    switch (window.APP_VENDOR) {
      case "snai":
        return "/registrazioneJwt/assets/banner/snai/giftbox.svg"
      case "pokerstars":
        return "/registrazioneJwt/assets/banner/pokerstars/giftbox.svg"
      default:
        return "/registrazioneJwt/assets/banner/giftbox.svg"
    }
  }

  return (
    <Image
      src={computeImageSrc()}
      alt="giftbox"
      width={20}
      height={20}
      className="inline-block"
    />
  )
}

function usePromoBannerText() {
  const promoCode = useSignupRequestStore((state) => state.data.activePromoCode)
  const bonusListQuery = useBonusListQuery()
  const t = useTranslations()

  if (bonusListQuery.isLoading) {
    return null
  }

  const buildNoPromoText = () => {
    if (promoCode) {
      return t("PromoBanner.finishSignupAndObtainWelcomeBonus")
    } else {
      return t("PromoBanner.specialBonusForYou")
    }
  }

  const bonusListData = bonusListQuery.data

  if (bonusListData == null || isErr(bonusListData)) {
    return buildNoPromoText()
  }

  const selectedBonusCard = bonusListData.value.bonus?.find(
    (b) => b.bonusCode === promoCode,
  )

  const bonusProductTitle = getBonusProductTitle(selectedBonusCard?.style)

  if (bonusProductTitle && selectedBonusCard?.title) {
    return (
      <>
        <Translate i18nKey="PromoBanner.activePrefix" />
        <strong>{`${bonusProductTitle} ${selectedBonusCard.title}`}</strong>
      </>
    )
  } else {
    return buildNoPromoText()
  }
}
